import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import CompanySlugDto from '@/features/dashboard/company/types/CompanySlugDto.ts';
import CompanyInfoDto from '@/features/dashboard/company/types/CompanyInfoDto.ts';
import UpdateCompanyInfoDto from '@/features/dashboard/company/types/UpdateCompanyInfoDto.ts';
import CompanyTimezoneDto from '@/features/dashboard/company/types/CompanyTimezoneDto.ts';
import { InitUploadRequest, InitUploadResponse } from '@/lib/upload/types.ts';

const companyApi = {
  getCompanySlug: async (): Promise<CompanySlugDto> => {
    return await fetchPrivateApi<CompanySlugDto>('GET', `company/slug`);
  },
  getCompanyTimezone: async (): Promise<CompanyTimezoneDto> => {
    return await fetchPrivateApi<CompanyTimezoneDto>(
      'GET',
      `settings/company/timezone`,
    );
  },
  getCompanyInfo: async (): Promise<CompanyInfoDto> => {
    return await fetchPrivateApi<CompanyInfoDto>('GET', `company`);
  },
  updateCompanyInfo: async (
    dto: UpdateCompanyInfoDto,
  ): Promise<CompanyInfoDto> => {
    return await fetchPrivateApi<CompanyInfoDto>('PUT', `company`, dto);
  },
  initLogoUpload: async (
    request: InitUploadRequest,
  ): Promise<InitUploadResponse> => {
    return await fetchPrivateApi<InitUploadResponse>(
      'POST',
      `company/logo/init-upload`,
      request,
    );
  },
  confirmLogoUpload: async (fileId: string): Promise<void> => {
    return await fetchPrivateApi<void>(
      'POST',
      `company/logo/${fileId}/confirm-upload`,
    );
  },
  removeCompanyLogo: async (): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `company/logo`);
  },
  getLogoDownloadUrl: async (fileId: string): Promise<string> => {
    return await fetchPrivateApi<string>(
      'GET',
      `company/logo/${fileId}/download-url`,
    );
  },
};

export default companyApi;
